import { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import { images } from '../../../Constants/ImageUrls';
import {
  applyGesture,
  handleWidgetAccToUser,
  useScrollToWidget,
} from '../../../Utils/productPageUtils';
import { categoryNameCollapsed, categoryNameExpanded } from './common';
import {
  BodyStyle,
  GridList,
  ListHeading,
  SectionContainer,
  SectionTitle,
} from './styled';

export default function TypeList(props) {
  const {
    itemData,
    clickedHandler,
    productCategory,
    index,
    Ido,
    clinic,
    WidgetContainImage,
    showNewLandingPageUI,
  } = props;
  const widgetIsOpened = Ido || !itemData.default_collapsed;
  const [openWidget, setOpenWidget] = useState(widgetIsOpened);
  const { forceOpenWidget } = useScrollToWidget('a++');
  const [plusMinusDropDown, setPlusMinusDropDown] = useState(
    openWidget ? images.minusSvg : images.plusBlack,
  );
  const [gestureEffect, setGestureEffect] = useState('');
  const [widgetHandle, setWidgetHandle] = useState({
    widgetImage: '',
    widgetClass: '',
  });
  const openReturnPolicyWidget =
    forceOpenWidget.includes('returnPolicy') && !!itemData?.is_policy;
  const handleWidgetState = (categoryNameState, widgetOpen, imageType) => {
    applyGesture(setGestureEffect);
    clickedHandler(categoryNameState, index, itemData.title);
    // setOpenWidget(widgetOpen);
    setPlusMinusDropDown(imageType);
  };
  useEffect(() => {
    if (openReturnPolicyWidget) {
      setOpenWidget(true);
    }
  }, [itemData, openReturnPolicyWidget]);

  useEffect(() => {
    handleWidgetAccToUser(plusMinusDropDown, setWidgetHandle);
  }, [plusMinusDropDown]);

  useEffect(() => {
    const state = widgetIsOpened;
    setOpenWidget(state);
  }, [itemData.default_collapsed]);

  useEffect(() => {
    if (openWidget)
      handleWidgetState(categoryNameExpanded, true, images.minusSvg);
    else handleWidgetState(categoryNameCollapsed, false, images.plusBlack);
  }, [openWidget]);

  return (
    <SectionContainer
      productcategory={productCategory}
      //onClick={clickedHandler}
      data-policy-widget={!!itemData?.is_policy}
      showNewLandingPageUI={showNewLandingPageUI}
    >
      <Collapsible
        trigger={
          <SectionTitle className={` ${gestureEffect} aplusTitleSize`}>
            {itemData.title}
            <img
              loading="lazy"
              src={widgetHandle.widgetImage}
              className={widgetHandle.widgetClass}
              alt="arrow"
            />
          </SectionTitle>
        }
        key={index}
        onOpening={() => {
          setOpenWidget(true);
        }}
        onClosing={() => {
          setOpenWidget(false);
        }}
        transitionTime={200}
        open={openWidget}
        triggerOpenedClassName="triggerClassAplus"
      >
        {itemData?.widgetContent?.map((item, index) => (
          <div key={`listWidgetGrid${index}`}>
            <GridList show={item.url}>
              {/* {item.url && (
                                <Image
                                    src={item?.url}
                                    alt={
                                        item?.imageAltName
                                            ? item?.imageAltName
                                            : `${item?.fallbackAltName}  ${itemData.title}`
                                    }
                                    width="18px"
                                    height="18px"
                                    loading="lazy"
                                />
                            )} */}

              {item?.heading ? (
                <ul>
                  <ListHeading>{item?.heading}</ListHeading>
                </ul>
              ) : (
                <ul>
                  <li>{item?.body}</li>
                </ul>
              )}
            </GridList>
            {item?.heading ? (
              <BodyStyle>
                <p>{item?.body}</p>
              </BodyStyle>
            ) : null}
          </div>
        ))}
      </Collapsible>
    </SectionContainer>
  );
}
